export default "/_next/static/images/advertCommunity-844bced314c9828c6605b925ab5fde71.png";